import { render } from "./ModifyPaymentPassword.vue?vue&type=template&id=3cd52766&scoped=true"
import script from "./ModifyPaymentPassword.vue?vue&type=script&lang=js"
export * from "./ModifyPaymentPassword.vue?vue&type=script&lang=js"

import "./ModifyPaymentPassword.vue?vue&type=style&index=0&id=3cd52766&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd52766"]])

export default __exports__